import { DashboardEventService } from './../dashboard/dashboard-event.service';
import { ServiceRegistry } from './../service/service-registry.service';
import { AwsUtil } from './../authentication/aws.service';
import { Correction, GetCorrectionsRequest, WebApiEndpoints, CORRECTION_TYPES, validateCorrection } from '@liquitics/transaction';
import { Injectable } from '@angular/core';
import { BaseRestService } from '../service/base-rest.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CorrectionService extends BaseRestService<void> {

    constructor(protected http: HttpClient,
        protected awsUtil: AwsUtil,
        protected serviceRegistry: ServiceRegistry,
        protected dashboardEventService: DashboardEventService) {
        super(http, awsUtil, serviceRegistry, dashboardEventService);
    }

    // registerService() {
    //     this.serviceRegistry.registerService(this);
    // }

    // getDataSubject() {
    //     return this.dataSubject$;
    // }

    // getAlertRowSubject(): Subject<AlertRow[]> {
    //     return this.alertRowSubject$;
    // }

    // startPolling() {
    //     super.startPolling();
    //     this.alertRowSubscription$
    //         .subscribe({next: (rows: AlertRow[]) => {
    //             this.alertRowSubject$.next(rows);
    //         });
    // }


    // protected makeAPICall(authToken: string, params?: any): Observable<void> {
    //     super.makeAPICall
    // }

    public saveCorrection(correction: Correction): Promise<void> {
        if (correction.type === CORRECTION_TYPES.PROJECTION_UPDATE && !correction.projectionUpdateOriginalAmount) {
            correction.projectionUpdateOriginalAmount = 0.0;
        }
        correction.username = this.awsUtil.cognitoUtil.getCurrentUser().getUsername();
        // TODO Validate this later, but current validator expects the auto-generated values too so...
        return this.awsUtil.webAPICall(WebApiEndpoints.SaveCorrection, correction, true);
    }

    public getCorrections(request: GetCorrectionsRequest): Observable<void> {
        return this.getDataObservable(request);
    }


    getAPIName(params?: any): string {
        if (params instanceof GetCorrectionsRequest) {
            return WebApiEndpoints.QueryCorrections;
        } else {
            return WebApiEndpoints.SaveCorrection;
        }
    }

    useDemoDataFile(): boolean {
        return false;
    }
}
